import {WorkstreamNodeType} from 'components/DSYS/editor/utils';

const SWITCHBOARD_PARENT_NODE_TYPES = new Set<WorkstreamNodeType>([
  'switchboard-link',
  'switchboard-name',
  'switchboard-objective',
  'switchboard-objective-editable',
  'switchboard-dri',
  'switchboard-exec-sponsor',
  'switchboard-working-group',
  'switchboard-eta',
  'switchboard-subworkstreams',
  'workstream-starred-milestones',
  // Legacy alias kept so existing switchboard templates keep pointing at parent sub-workstreams.
  'workstream-subworkstreams',
]);

export const isSwitchboardParentNodeType = (nodeType: WorkstreamNodeType): boolean =>
  SWITCHBOARD_PARENT_NODE_TYPES.has(nodeType);

export const resolveSwitchboardNodeWorkstreamId = ({
  nodeType,
  switchboardId,
  switchboardSubWorkstreamIds,
  workstreamIndex,
}: {
  nodeType: WorkstreamNodeType;
  switchboardId: number;
  switchboardSubWorkstreamIds: number[];
  workstreamIndex?: number;
}): number | null => {
  if (isSwitchboardParentNodeType(nodeType)) {
    return switchboardId;
  }

  if (workstreamIndex === undefined) {
    return null;
  }

  return switchboardSubWorkstreamIds[workstreamIndex] ?? null;
};
